import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSection, TutorialSlide } from "../../tutorial.models";

export const PROFILE_SETTINGS_SLIDES: TutorialSlide[] = [
    {
        key: 'WelcomeCard',
        title: 'Welcome! 👋',
        messages: [{ text: "Let's dive into organizing your medical admin. While settings may not be the most thrilling task, it's important to get it right. By completing this, you'll help MedicAI understand your practice and train your AI Assistant to think like you." }],
        actions: [
            {
                text: 'Get Started',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.PREFERRED_MEDICATION_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.MEDICATION_BUNDLES_CREATED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.LETTERHEAD_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.HAS_HOSPITALS, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.NETWORK_COMPLETE, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.PRACTICE_PROFILE_COMPLETE, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.SIGNATURE_SET, type: SlideHideConditionType.AND },
        ],
    },
    {
        key: 'Add-Signature',
        title: 'Add Signature',
        messages: [
            { text: "First, let's edit your profile and add your signature. You'll need this for any scripts or letters that require a signature." },
            //{ text: 'Click "edit" and add your signature. We strongly suggest you add your signature now', class: 'primary' },
        ],
        expansionTarget: 'USER_PROFILE',
        highlightTarget: 'USER_PROFILE',
        forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_PHYSICIAN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.SIGNATURE_SET, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-Practice',
        title: 'Add Practice Profile',
        messages: [
            { text: "Next, we need details about your practice. This information will help us inform patients about your practice when we send them an invite to onboard." },
            //{ text: 'Click "edit" on your practice profile and fill in the details.', class: 'primary' },
        ],
        expansionTarget: 'PRACTICE_PROFILE',
        highlightTarget: 'PRACTICE_PROFILE',
        forceOpenTarget: true,
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.PRACTICE_PROFILE_COMPLETE, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-Doctors',
        title: 'Build Your Team',
        expansionTarget: 'PRACTICE_NETWORK',
        highlightTarget: 'PRACTICE_NETWORK',
        forceOpenTarget: true,
        messages: [
            { text: "Now, let's get your team involved! Add your secretaries, PAs, and Clinical Associates so they can invite patients and manage your schedule. If you work with other doctors on a shared patient list, be sure to include them too." },
            // { text: 'Click "add person" next to Practice Network.', class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_PHYSICIAN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.NETWORK_COMPLETE, type: SlideHideConditionType.OR },
        ],
    },
    /* {
        key: 'Add-Doctors',
        title: 'Add Doctors',
        expansionTarget: 'PRACTICE_NETWORK',
        highlightTarget: 'PRACTICE_NETWORK',
        forceOpenTarget: true,
        keepDialogOpen: true,
        messages: [
            { text: "As part of your doctor's admin team, getting patients onboarded at your practice is super important. You need to have a file ready for each patient, complete with their personal information, medical aid details, and medical history. Plus, it's crucial to have their consent to store their personal information. Without that consent, your practice could face legal issues.That's where MedicAI comes in! It makes the whole process seamless, reduces your stress, and organizes all the information efficiently—consented and ready to go in no time." },
            { text: 'Click "add person" next to Practice Network.', class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.IS_PHYSICIAN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.NETWORK_COMPLETE, type: SlideHideConditionType.OR },
        ],
    },
     {
         key: 'Add-Rules',
         title: 'User Rules',
         highlightTarget: 'PRACTICE_NETWORK',
         forceOpenTarget: true,
         keepDialogOpen: true,
         messages: [
             { text: "1. 'Support Staff (Limited)' can access EMR features only." },
             { text: "2. 'Support Staff (Unlimted)' has access to EMR features as well as AI recording features." },
             { text: "3. 'Physician' has access to EMR features as well as AI recording features." },
             { text: "4. 'Admin' has access to all features including practice settings." },
         ],
         actions: [
             {
                 text: 'Next',
                 color: 'primary',
                 actionName: SlideAction.SHOW_NEXT_SLIDE,
             },
         ],
         position: { x: 150, y: 450 },
         hideConditions: [
             { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
             { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
             { condition: SlideHidePageCondition.NETWORK_COMPLETE, type: SlideHideConditionType.OR },
         ],
     }, */
    {
        key: 'Add-Hospital',
        title: 'Add Hospital',
        expansionTarget: 'ASSOCIATED_HOSPITALS',
        highlightTarget: 'ASSOCIATED_HOSPITALS',
        forceOpenTarget: true,
        messages: [
            { text: "Alright, let's list the hospitals you work at and the wards where you admit patients. This will help your inpatient list accurately reflect your admitted patients." },
            //{ text: 'Click "add hospitals" next to Associated Hospitals.', class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.HAS_HOSPITALS, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-Letterhead',
        title: 'Add Letterhead',
        expansionTarget: 'LETTERHEAD',
        highlightTarget: 'CLEAR',
        messages: [
            { text: "To ensure your letters maintain a professional look, please upload your letterhead. This way, all your practice communications — whether to colleagues or patients — will include your branding, logo, and practice details. Snip the header and footer separately (1200px x 200px) for easy integration." },
            { text: 'Do it now!', class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.LETTERHEAD_SET, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Add-medBundles',
        title: 'Add Medication Bundles',
        expansionTarget: 'MEDICATION_BUNDLES',
        highlightTarget: 'MEDICATION_BUNDLES',
        forceOpenTarget: true,
        messages: [
            { text: "Most practices frequently prescribe similar medication bundles. Let's save you time by creating these bundles. This way, your AI Assistant can pick them up and prescribe appropriately under your supervision. Think along the lines of a combination of analgesics and antibiotics that you often use, or a migraine cocktail that you commonly prescribe." },
            // { text: 'Set this up now, but remember, you can always come back later.', class: 'primary' },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_PHYSICIAN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.MEDICATION_BUNDLES_CREATED, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.IS_ALLIED_SPECIALTY, type: SlideHideConditionType.OR },
        ],
        position: { x: 150, y: 450 },
    },
    {
        key: 'Add-predMed',
        title: 'Add Preferred Medication',
        expansionTarget: 'PREFERRED_MEDICATION',
        highlightTarget: 'PREFERRED_MEDICATION',
        forceOpenTarget: true,
        messages: [
            { text: "Your AI Assistant will also recommend medications based on your recorded consultations. To help it suggest your preferred formulations, list your go-to branded medications here. If done right, this can really save you time!" },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_PHYSICIAN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.PREFERRED_MEDICATION_SET, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.IS_ALLIED_SPECIALTY, type: SlideHideConditionType.OR },
        ],
        position: { x: 150, y: 450 },
    },
    {
        key: 'Heads-up',
        title: 'Heads Up',
        expansionTarget: 'SUPPORT_CONTACT',
        highlightTarget: 'CLEAR',
        keepDialogOpen: false,
        messages: [
            { text: "If you have any questions or need assistance at any point, feel free to send us a support request." },
        ],
        actions: [
            {
                text: 'Next',
                color: 'primary',
                actionName: SlideAction.SHOW_NEXT_SLIDE,
            },
        ],
        position: { x: 150, y: 450 },
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR },
        ],
    },
    {
        key: 'Profile_Finish',
        title: 'Completed Profile Settings!',
        messages: [
            { text: "You are 30% done!" },
        ],
        expansionTarget: 'USER_PROFILE',
        highlightTarget: 'CLEAR',
        hasBackdrop: true,
        //position: { vertical: 'center', horizontal: 'center' },
        dimensions: { width: '450px' },
        actions: [
            {
                text: 'Carry on - Recommended',
                color: 'primary',
                actionName: SlideAction.START_NOTE_TUTORIAL,
            },
            {
                text: 'Continue Later',
                color: 'warn',
                actionName: SlideAction.CLOSE_TUTORIAL,
                suffixText: 'Continue Later'
            },

        ],
        position: { x: 700, y: 350 },
        progressBar: 30,
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.NOT_ADMIN_USER, type: SlideHideConditionType.OR },
            { condition: SlideHidePageCondition.PREFERRED_MEDICATION_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.MEDICATION_BUNDLES_CREATED, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.LETTERHEAD_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.HAS_HOSPITALS, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.NETWORK_COMPLETE, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.PRACTICE_PROFILE_COMPLETE, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.SIGNATURE_SET, type: SlideHideConditionType.AND },
            { condition: SlideHidePageCondition.DIALOG_SLIDE_HIDDEN, type: SlideHideConditionType.OR }, // This condition is required
        ],
    },
];